import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getRescueSelector } from '../selectors'
import { saveRescue } from '../store/rescue.actions'
import { RescueConstants } from '../store/rescue.constants'
import { IRescueState } from '../store/rescue.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const rescueState: IRescueState = yield select(getRescueSelector)
  const { successfulAttempt } = rescueState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.rescueStateList && pcrDoc.patient?.rescueStateList.length) {
        const index = pcrDoc.patient?.rescueStateList?.findIndex((rescue) => rescue.key === rescueState.key)
        if (index !== -1) {
          if (pcrDoc.patient.rescueStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveRescue())
          }
        }
      } else {
        yield put(saveRescue())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([RescueConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
